import { AxiosInstance } from 'axios';
import { generateCustomHttpClient } from './factory';
import {
  onFullFilledAuthRequestInterceptor,
  onRejectedAuthResponseInterceptor,
} from './interceptors/auth';
import { reqFullfilled, resRejected } from './utils';

const MARKETPLACE_CORE_TIMEOUT_IN_MS = 30_000;

/**
 * An object containing pre-configured HTTP clients for different services.
 * Each client is set up with its own base URL and any necessary interceptors.
 *
 * To add a new service client, simply add a new entry to this object.
 * Example:
 * ```typescript
 * 'newService': generateCustomHttpClient(
 *   {
 *     baseURL: getServiceBaseUrl({
 *       basePrefix: process.env.NEXT_PUBLIC_NEW_SERVICE_BASE_PREFIX!,
 *     }),
 *   },
 *   {
 *     interceptors: {
 *       request: [reqFullfilled(yourRequestInterceptor)],
 *       response: [resRejected(yourResponseInterceptor)],
 *     },
 *   }
 * ),
 * ```
 */
const httpClient: Record<string, AxiosInstance> = {
  izmoAuth: generateCustomHttpClient(
    {
      baseURL: process.env.NEXT_PUBLIC_IZMO_AUTH_API_BASE_URL,
    },
    {
      interceptors: {
        request: [reqFullfilled(onFullFilledAuthRequestInterceptor)],
        response: [resRejected(onRejectedAuthResponseInterceptor)],
      },
    }
  ),
  marketplaceCore: generateCustomHttpClient(
    {
      baseURL: process.env.NEXT_PUBLIC_MARKETPLACE_CORE_API_BASE_URL,
      timeout: MARKETPLACE_CORE_TIMEOUT_IN_MS,
    },
    {
      interceptors: {
        request: [reqFullfilled(onFullFilledAuthRequestInterceptor)],
        response: [resRejected(onRejectedAuthResponseInterceptor)],
      },
    }
  ),
  healthcareIntelligence: generateCustomHttpClient(
    {
      baseURL: process.env.NEXT_PUBLIC_HEALTHCARE_INTELLIGENCE_API_BASE_URL,
    },
    {
      interceptors: {
        request: [reqFullfilled(onFullFilledAuthRequestInterceptor)],
        response: [resRejected(onRejectedAuthResponseInterceptor)],
      },
    }
  ),
  healthyoneTransaction: generateCustomHttpClient(
    {
      baseURL: process.env.NEXT_PUBLIC_HEALTHYONE_TRANSACTION_API_BASE_URL,
    },
    {
      interceptors: {
        request: [reqFullfilled(onFullFilledAuthRequestInterceptor)],
        response: [resRejected(onRejectedAuthResponseInterceptor)],
      },
    }
  ),
  healthyoneMarketplace: generateCustomHttpClient({
    baseURL: process.env.NEXT_PUBLIC_HEALTHYONE_MARKETPLACE_API_BASE_URL,
  }),
  voluspaImageToText: generateCustomHttpClient({
    baseURL: process.env.NEXT_PUBLIC_VOLUSPA_IMAGETOTEXT_URL,
  }),
} as const;

export default httpClient;
